import {Map, Iterator} from 'immutable';

export type pureFunc = (...args: any[]) => any;

export class FilterController {
    private store: Map<string, pureFunc>;

    constructor() {
        this.store = Map();
    }

    public setFilter(funcName: string, func: pureFunc) {
        if (this.store.has(funcName)) {
            throw new Error('found exist func : ' + funcName);
        }

        if (typeof func === 'function') {
            let f = func;
            func = ((...args: any[]) => {
                try {
                    return f(...args);
                } catch (e) {
                    console.error(e);
                    return null;
                }
            });
        }

        this.store = this.store.set(funcName, func);
    }

    public getFilter(funcName: string) {
        if (!this.store.has(funcName)) {
            console.error('can not find target func :' + funcName);
            return (...args: any[]) => args;
        }

        return this.store.get(funcName);
    }

    public hasFilter(funcName: string) {
        return this.store.has(funcName);
    }

    public getAllFilterName(): Iterator<string> {
        return this.store.keys();
    }

    public delFilter(funcName: string) {
        this.store = this.store.delete(funcName);
    }

    public clearFilter() {
        this.store = Map();
    }

    public size() {
        return this.store.size;
    }
}

export const filter = new FilterController();



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/render/util/filter.ts